import type { SupportContent } from "./types";

export const supportEn: SupportContent = {
  seo: {
    title: "Support - Luxoria",
    description: "Get help with HDR conversion, saving, and exported results in Luxoria."
  },
  tag: "Support",
  title: "Support for Luxoria",
  subtitle:
    "Need help with HDR conversion, saving, or exported results? Contact us and include the details below.",
  contactLabel: "Email",
  contactNote: "We read every message. Please include the details listed so we can help faster.",
  issueTitle: "When reporting an issue, please include",
  issueItems: [
    "Device model",
    "System version",
    "Luxoria version",
    "Media type: photo, batch photos, or video",
    "What you were trying to do",
    "What happened instead"
  ],
  faqTitle: "Frequently asked questions",
  faqGroups: [
    {
      title: "About Luxoria",
      items: [
        {
          question: "What is Luxoria?",
          answer:
            "Luxoria is an HDR conversion app for photos and videos. It helps convert SDR media into HDR-ready outputs."
        },
        {
          question: "What media is supported?",
          answer:
            "Single photos, batch photos, and videos. Videos export to HEVC Main10 HLG output."
        },
        {
          question: "Will it change my original files?",
          answer:
            "No. Luxoria creates converted outputs and leaves your selected source media untouched."
        }
      ]
    },
    {
      title: "Conversion & export troubleshooting",
      items: [
        {
          question: "Why does video conversion take time?",
          answer:
            "Video HDR conversion requires frame-level processing and export, so longer or higher-resolution videos take more time."
        },
        {
          question: "Why does HDR look different across screens or apps?",
          answer:
            "HDR rendering depends on the display, operating system, viewer app, and whether the device supports HDR playback, so the same file can look different in different environments."
        },
        {
          question: "Where are exported files saved?",
          answer:
            "Depending on the platform and your selection, outputs can be saved to Photos, Files, or a selected folder."
        }
      ]
    }
  ],
  links: [
    { label: "Privacy Policy", kind: "privacy" },
    { label: "Terms of Use", kind: "terms" },
    { label: "Back to Luxoria", kind: "landing" }
  ]
};
